import { cryptoSymbolsByNameNew } from 'common/constants';
import { Instrument } from 'components/types';
import React, { useEffect, useRef, memo } from 'react';

interface CryptoChartsWidgetProps {
    instrument: Instrument; 
}

function CryptoChartsWidget({instrument}: CryptoChartsWidgetProps) {
  const container = useRef<HTMLDivElement | null>(null);
 
  useEffect(() => {
    console.log('instrument', instrument);  
    const currentSymbol = cryptoSymbolsByNameNew[instrument.name.toLowerCase()];
    if (!currentSymbol) return;
    container?.current?.replaceChildren();
    
    const script = document.createElement('script');
    script.src =
      'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
        {
          "autosize": true,
          "symbol": "BINANCE:${currentSymbol}USDT",
          "interval": "30",
          "timezone": "America/New_York",
          "theme": "light",
          "style": "1",
          "locale": "en",
          "hideideas": true,
          "toolbar_bg": "#f1f3f6",
          "enable_publishing": false,
          "allow_symbol_change": false,
          "support_host": "https://www.tradingview.com",
          "customer": "kitco"
        }`;
    container?.current?.appendChild(script);

  }, [instrument, instrument.name]);

  return (
    <div
      className='tradingview-widget-container'
      ref={container}
      style={{ height: '100%', width: '100%' }}
    >
      <div
        className='tradingview-widget-container__widget'
        style={{ height: 'calc(100% - 32px)', width: '100%' }}
      ></div>
    </div>
  );
}

export default memo(CryptoChartsWidget);
